@if (isLoading()) {
  <ngx-skeleton-loader
    class="skeleton"
    [theme]="{ width: '100%', height: '100%', background: 'var(--alt-bg2)', opacity: 0.25 }"
  ></ngx-skeleton-loader>
} @else {
  <canvas
    baseChart
    type="bar"
    [data]="chartData()"
    [options]="chartOptions()"
  ></canvas>
}
